import ExamResultsCard from './ExamResultsCard';

export default ExamResultsCard;
